module.exports = __webpack_public_path__ + "img/feedback old.056e261a.webp";